<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    :fill="color"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ color }"
  >
    <path
      d="M2.05128 12.1026C3.18417 12.1026 4.10256 11.1842 4.10256 10.0513C4.10256 8.91839 3.18417 8 2.05128 8C0.91839 8 0 8.91839 0 10.0513C0 11.1842 0.91839 12.1026 2.05128 12.1026Z"
    ></path>
    <path
      d="M10.0513 12.1026C11.1842 12.1026 12.1026 11.1842 12.1026 10.0513C12.1026 8.91839 11.1842 8 10.0513 8C8.91839 8 8 8.91839 8 10.0513C8 11.1842 8.91839 12.1026 10.0513 12.1026Z"
    ></path>
    <path
      d="M17.9487 12.1026C19.0816 12.1026 20 11.1842 20 10.0513C20 8.91839 19.0816 8 17.9487 8C16.8158 8 15.8974 8.91839 15.8974 10.0513C15.8974 11.1842 16.8158 12.1026 17.9487 12.1026Z"
    ></path>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'MoreSVG',
  props: {
    size: VueTypes.number.isRequired,
    color: VueTypes.string.isRequired,
  },
};
</script>

<style></style>
